import ToggleFavouriteProperty from "./ToggleFavouriteProperty";

export default ToggleFavouriteProperty;
